<template>
    <div class="total-test">

        <Card class="p-m-3" :class="{'card-loading': isLoading}">

            <template #title>
                <div style="height: .5em;     margin: -0.5em;">
                    <ProgressBar
                            class="p-m-0 p-p-0"
                            v-if="isLoading"
                            mode="indeterminate"
                            style="height: .5em"
                    />
                </div>
                <h2>התקדמות לימודים</h2>
            </template>
            <template #content>
                <div class="p-grid p-justify-center">
                    <select-lesson use-store storage-name="pupil-study-time-line" navigateButtons class="select-lesson p-col-12 p-pb-3" v-on:onSelect="onChangeLesson"/>

                    <h3 class="no-content" v-if="!isLoading && !subject">יש לבחור מקצוע</h3>
                    <h3 class="no-content" v-if="!isLoading && subject && lessonsTracking.length === 0">אין נתונים
                        להצגה</h3>
                    <ScrollPanel style="width: 100%; max-height: 200px">
                        <div id="zz" style=" width: 100%; ">
                            <div class="p-p-3" style=" ">
                                <Timeline tooltipField="statusHebrewname" align="left" :value="lessonsTracking">
                                    <template #opposite="slotProps">
                                        <small class="p-text-secondary">{{ parseDate(slotProps.item.date) }}</small>
                                    </template>
                                    <template #marker="slotProps">
			<span class="custom-marker shadow-2" :style="{backgroundColor: getPresenceColor(slotProps.item.status)}">
			</span>
                                    </template>
                                    <template #content="slotProps">
                                        <h3 style="line-height: normal;"> {{ slotProps.item.content }}</h3>
                                    </template>
                                </Timeline>
                            </div>
                        </div>
                        <ScrollTop  target="parent" :threshold="30" class="custom-scrolltop"
                                   icon="pi pi-arrow-up"/>
                    </ScrollPanel>
                </div>

            </template>
        </Card>
    </div>

</template>

<script>
import SelectLesson from "@/components/selects/SelectLesson";
import axios from "axios";
import {dateToFullHebrew} from "@/utils/hebrewDateFormat";
import {getPresence} from "@/utils/parseObj";

export default {
    name: "LessonTimeLine",
    components: {SelectLesson},
    props: {pupil: Object, startDate: Number, endDate: Number},
    data() {
        return {
            lessonsTracking: [],
            subject: null,
            isLoading: false,
        }
    },
    watch: {
        pupil() {
            this.initData();
        },
        startDate() {
            this.initData();
        },
        endDate() {
            this.initData();
        }
    },
    methods: {
        async initData() {
            this.isLoading = true
            const {data} = await axios.get(`study/pupil-presence/${this.pupil.id}/${this.subject.id}/${this.startDate}/${this.endDate}`)
            data.forEach(s => s.statusHebrewname = this.getPresence(s?.status)?.hebrewName || 'נוכח')
            this.lessonsTracking = data
            this.isLoading = false

        },
        parseDate(date) {
            return dateToFullHebrew(date)
        },
        getPresence(id) {
            return getPresence(id)
        },
        getPresenceColor(id) {
            return getPresence(id)?.color
        },
        onChangeLesson(lesson) {
            this.subject = lesson
            this.initData()
            // alert(lesson.hebrewName)
            // const

        }
    },
}
</script>

<style scoped>
.no-content {
    text-align: center;
    color: #999999;
}

.p-timeline .custom-marker {
    border: 2px solid #7f878d;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    background-color: #ffffff;
}

.select-lesson {

    display: flex;
    justify-content: center;
}
</style>